"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = exports.LocationMessage = exports.NonBookableLocationContainer = exports.BookableLocationContainer = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
exports.BookableLocationContainer = (0, styled_1.default)('div') `
  input[type='checkbox'],
  label {
    ${(props) => props.disabled && 'cursor: not-allowed'}
  }
`;
exports.NonBookableLocationContainer = (0, styled_1.default)('div') `
  flex-direction: column;

  a,
  a:visited {
    color: ${(0, ui_theme_1.fromTheme)('color_providermatch')};
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  }

  > div {
    &:first-of-type {
      display: flex;
      // phone icon
      > svg {
        margin-right: ${(0, ui_theme_1.fromTheme)('spacing_small')};
      }
    }
  }
`;
exports.LocationMessage = (0, styled_1.default)('div') `
  border: 1px solid ${(0, ui_theme_1.fromTheme)('color_border')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  background: ${(0, ui_theme_1.fromTheme)('color_background_secondary')};
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  border-radius: 2px;
`;
exports.List = (0, styled_1.default)('ul') `
  max-height: 25rem;
  overflow-y: scroll;
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  list-style: none;
  padding: 0;
  margin: 0;

  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    border-top: 1px solid ${(0, ui_theme_1.fromTheme)('color_border')};
  }

  li {
    transition: background-color 350ms;
    margin: 0;
    border-bottom: 1px solid ${(0, ui_theme_1.fromTheme)('color_border')};
    &:last-child {
      border: none;
    }

    > div {
      padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
      display: flex;
      align-items: flex-start;

      > label {
        margin-right: ${(0, ui_theme_1.fromTheme)('spacing_small')};
        // Align checkbox with location name
        margin-top: 3px;
      }

      p {
        margin: 0;
        line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
        color: ${(0, ui_theme_1.fromTheme)('color_text')};
      }

      h5 {
        color: ${(0, ui_theme_1.fromTheme)('color_text')};
        margin: 0;
        padding: 0;
        font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
        font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
        margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
      }
    }
  }
`;
//# sourceMappingURL=styles.js.map